import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import loader from "../../assets/Images/loader.gif";
import imageCompression from 'browser-image-compression';

const InstallationWCR = () => {
  const [activeForm, setActiveForm] = useState("form1");
  const [attachForm, setAttachForm] = useState("");
  const [getWcrInfo, setWcrInfo] = useState("");
  const [engDetails, setEngDetails] = useState({});
  const [speedTest, setSpeedTest] = useState("");
  const [cableCrimp, setCableCrimp] = useState("");
  const [facePlate, setFacePlate] = useState("");
  const [ontLogin, setOntLogin] = useState("");
  const [wifiSsid, setWifiSsid] = useState("");
  const [selectScp, setSelectScp] = useState("");
  const [selectAntiVirus, setSelectAntiVirus] = useState("");
  const [loaders, setLoaders] = useState(false);
  const [documentfile, setDocumentfile] = useState("");
  const [fileName, setFileName] = useState("");
  const [base64Content, setBase64Content] = useState("");

  const [holdOpts,setHoldOpts] = useState([])
  const [holdCategory,setHoldCategory]= useState("")
  const [WCRGUIDID,setWCRGUIDID]= useState("")
  const [engCreatedOn,setEngCreatedOn]= useState('')
 const [engHoldReason,setEngHoldReason]= useState()


  // State for Wi-Fi
  const [wifiSpeed, setWifiSpeed] = useState(
    getWcrInfo[0] ? getWcrInfo[0].CusotmerNetwork.SpeedWifi : ""
  );
  const [fileNameSpeedWF, setFileNameSpeedWF] = useState("");
  const [base64StringSpeedWF, setBase64StringSpeedWF] = useState("");

  // State for LAN
  const [lanSpeed, setLanSpeed] = useState(
    getWcrInfo[0] ? getWcrInfo[0].CusotmerNetwork.SpeedLan : ""
  );
  const [fileNameSpeedLAN, setFileNameSpeedLAN] = useState("");
  const [base64StringSpeedLAN, setBase64StringSpeedLAN] = useState("");

  const [userWcrData, setUserWcrData] = useState({
    wifiSsid: "",
    RxPower: "",
    TxPower: "",
    installationCode: "",
    remark: "",
    miscWorkCost: "",
  });

  const handleChange = (e) => {
    // console.log(e.target.name, e.target.value);
    setUserWcrData({ ...userWcrData, [e.target.name]: e.target.value });
  };

  const navigate = useNavigate();
  const optionSpeedTest = [
    { value: "", label: "Select Type" },
    { value: "111260000", label: "Yes" },
    { value: "111260001", label: "No" },
  ];
  // const optionPgWifiBill = [
  //   { value: "Yes", label: "Yes" },
  //   { value: "No", label: "No" },
  // ];
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };


 // Utility function to convert dd/MM/yyyy to yyyy-MM-dd
const formatToInputDate = (dateString) => {
  if (!dateString) return ''; // Check if dateString is defined
  const [day, month, year] = dateString.split('/');
  return `${year}-${month}-${day}`;
};
  

  useEffect(() => { 
    if (engDetails) {
        // console.log("santa",engDetails.HoldReason);
        setEngHoldReason(engDetails.HoldReason)
        const formattedDate = formatToInputDate(engDetails.WCRCreatedon);
        setEngCreatedOn(formattedDate);
    }
  }, [engDetails]);
   const handleCreatedOn = (e) =>{
    setEngCreatedOn(e.target.value)
   }

   const handleSelectHoldReason = (e) => {
   
    setEngHoldReason(e.target.value)
   }

  const handleIconClick = (formId) => {
    setAttachForm("");
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  const handleAttachmentClick = async (formId) => {
    setAttachForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
    setActiveForm("");
    try {
      setLoaders(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getWCRIRDocument",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        irId: "",
        wcrId: sessionStorage.getItem("wcrId"),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      // console.log("API Response:", data);

      if (data.Response.StatusCode === 200) {
        setDocumentfile(data.Response.Data);
        setLoaders(false);
      } else {
        // const errorMessage = data && data.Response && data.Response.Message;
        //   console.log("errorMessage",errorMessage);
        toast.warning("Please wait...", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 500,
        });
        setLoaders(false);
      }
    } catch (error) {
      console.error("Error fetching hold categories:", error);
    }
  };

  const handleSelectSpeedTest = (speedTest) => {
    setSpeedTest(speedTest);
  };

  const handleSelectCableCrimp = (cable) => {
    setCableCrimp(cable);
  };
  const handleSelectFacePlate = (plate) => {
    setFacePlate(plate);
  };
  const handleSelectOntLogin = (ont) => {
    setOntLogin(ont);
  };

  const handleSelectWifiSsid = (wifissid) => {
    setWifiSsid(wifissid);
  };

  const handleSelectScp = (scp) => {
    setSelectScp(scp);
  };

  const handleSelecAntiVirus = (antivirus) => {
    setSelectAntiVirus(antivirus);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        //   setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "ffaGetWCRInfo",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CanId: sessionStorage.getItem("CanId"),
          OrderId: sessionStorage.getItem("OrderID"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log('API Response:', result);
          if (
            result &&
            result.Response &&
            result.Response.Status !== "Failure"
          ) {

            // console.log('get WCR Actual Data:', result.Response);
            setEngDetails(result.Response.EngineerDetails)

            setUserWcrData({
              wifiSsid: result.Response.CusotmerNetwork.WifiSSID
                ? result.Response.CusotmerNetwork.WifiSSID
                : "",
              RxPower: result.Response
                ? result.Response.CusotmerNetwork.RxPower
                : "",
              TxPower: result.Response
                ? result.Response.CusotmerNetwork.TxPower
                : "",
              installationCode: result.Response
                ? result.Response.EngineerDetails.InstCode
                : "",
              remark: result.Response
                ? result.Response.EngineerDetails.WCRRemarks
                : "",
              miscWorkCost: result.Response
                ? result.Response.WCR.miscWorkCost
                : "",
            });
            let tt = [];
            tt.push(result.Response);
            setWcrInfo(tt);
            // console.log("ffaGetWCRInfo", result.Response, "tt", tt);

            sessionStorage.setItem("wcrId", result.Response.WCR.WCRGUIDID);
            setWCRGUIDID(result.Response.WCR.WCRGUIDID);
          } else {
            const errorMessage =
              result && result.Response && result.Response.Message;
            // console.log("errorMessage",errorMessage);
            toast.warning(`${errorMessage}`, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        //   setLoading(false);
      }
    };
    fetchData();
  }, []);

  // useEffect(() => {
  //   const fetchHoldCategories = async () => {
  //     try {
  //       setLoaders(true);
  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         Action: "getWCRIRDocument",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         irId: "",
  //         wcrId: sessionStorage.getItem("wcrId"),
  //       };
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const data = await response.json();
  //       console.log("API Response:", data);

  //       if (data.Response.StatusCode === 200) {
  //         setDocumentfile(data.Response.Data);
  //         setLoaders(false);
  //       }else{
  //           // const errorMessage = data && data.Response && data.Response.Message;
  //       //   console.log("errorMessage",errorMessage);
  //         toast.warning("Please wait...", {
  //           position: toast.POSITION.BOTTOM_CENTER,
  //           autoClose: 500,
  //         });
  //         setLoaders(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching hold categories:", error);
  //     }
  //   };

  //   fetchHoldCategories();
  // }, []);

  const handleWifiSpeedChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setWifiSpeed(value);
    }
  };
  const handleSpeedWFFileChange = async (event) => {
    const file = event.target.files[0];
    // Set compression options
    const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
    if (file) {
      setFileNameSpeedWF(file.name);
      // Convert file to Base64 string
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64StringSpeedWF(reader.result);
        // console.log("reader.result", reader.result);
      };
      reader.readAsDataURL(compressedFile);
    }
  };

  const handleLanSpeedChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setLanSpeed(value);
    }
  };
  const handleSpeedLANFileChange = async (event) => {
    const file = event.target.files[0];
    // Set compression options
    const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
    if (file) {
      setFileNameSpeedLAN(file.name);
      // Convert file to Base64 string
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64StringSpeedLAN(reader.result);
        // console.log("reader.result", reader.result);
      };
      reader.readAsDataURL(compressedFile);
    }
  };

  const openCameraCN = (inputId, id) => {
    // console.log("Button clicked:", id);
    if (id === "speedWifi") {
      setWifiSpeed("");
    } else if (id === "speedLan") {
      setLanSpeed("");
    }
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.click();
    }
  };

  const openCamera = () => {
    document.getElementById("cameraFileInput").click();
  };

  const isValidBase64 = (base64String) => {
    // Regular expression to check if the string is valid base64
    const base64Regex = /^[a-zA-Z0-9+/]*={0,2}$/;
    return base64Regex.test(base64String);
  };

  const handleDownload = (fileName, base64String) => {
    try {
      // console.log('Downloading file:', fileName, base64String); // Add logging here
      if (
        !base64String ||
        typeof base64String !== "string" ||
        !isValidBase64(base64String)
      ) {
        throw new Error(
          "Base64 string is missing, invalid, or not properly encoded."
        );
      }
      // Create blob from base64 string
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray]);
      // Create download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      // Append link to the body, trigger download, and remove link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
     // Set compression options
     const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(";base64,")[1];
      // console.log('File content:', base64String); // Log base64 content
      const inputText = "Picture Captured";
      setFileName(inputText); // Set the input text
      setBase64Content(base64String); // Set the base64 content
    };
    reader.readAsDataURL(compressedFile);
  };

  const redirectProvisoning = () => {
    navigate("/installationprovisioning");
  };

  const redirectToAddItem = () => {
    navigate("/ItemConsumption");
  };

  const redirectToAddEqup = () => {
    navigate("/addEquipment");
  };

  const redirectServiceConsumpton = () => {
    navigate("/serviceConsumpton");
  };

  const handleDeleteItem = async (e) => {
    // console.log("eee",e);
    const apiUrl = process.env.REACT_APP_API_URL;
    const requestData = {
      Action: "deleteItemConsumtionByID",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      ItemId: e,
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    if (result && result.Response && result.Response.Status !== "Failure") {
      navigate("/installationWCR");

      // setSubItem(result.Response);
    } else {
      const errorMessage = result && result.Response && result.Response.Message;
      //   toast.warning(`${errorMessage}`, {
      //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
      // });
    }
  };

  useEffect(() => {
    const fetchOnHoldCategory = async () => {
      try {
        setLoaders(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "WCRholdCategories",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        // console.log("API Response On hold Category:", data);

        const holdOptions = data.Response.WCR_Hold_Category.map((item) => ({
          value: item.ID,
          label: item.Category,
        }));
        setHoldOpts(holdOptions);
      } catch (error) {
        console.error("Error fetching hold categories:", error);
      }
    };

    fetchOnHoldCategory();
  }, []);

  const handleSelectHoldCategory = (selectedOpt) => {
    // console.log("selectedOpt", selectedOpt);
    setHoldCategory(selectedOpt);
  };
  //  const handleSelectHoldReason = (selectedOpt) =>{
  //   console.log('selectedOpt',selectedOpt)
  //    setHoldReason(selectedOpt)
  //  }

  const handleSaveCustomerNetwork = async () => {
    const wifiBase64Content = base64StringSpeedLAN.split(",")[1];
    const lanBase64Content = base64StringSpeedWF.split(",")[1];

    const apiUrl = "process.env.REACT_APP_API_URL";
    const requestData = {
      Action: "updateCustomerNetwork",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      RxPower: userWcrData.RxPower,
      SpeedLan: lanSpeed,
      SpeedWifi: wifiSpeed,
      TxPower: userWcrData.TxPower,
      WCRguidId: WCRGUIDID,
      WifiSSID: userWcrData.wifiSsid,
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();

    const apiUrl1 = "process.env.REACT_APP_API_URL";
    const requestData1 = {
      Action: "uploadWCRDoc",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      WCRguidId: WCRGUIDID,
      LanFileContent: lanBase64Content,
      LanFileName: fileNameSpeedLAN,
      WifiFileContent: wifiBase64Content,
      WifiFileName: fileNameSpeedWF,
    };

    const response1 = await fetch(apiUrl1, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData1),
    });

    const result1 = await response1.json();
  };

  const handleSaveInstallation = async () => {
    const speed = speedTest.value;
    const cable = cableCrimp.value;
    const face = facePlate.value;
    const ont = ontLogin.value;
    const wifissid = wifiSsid.value;
    const scp = selectScp.value;
    const virus = selectAntiVirus.value;

    const apiUrl = "process.env.REACT_APP_API_URL";
    const requestData = {
      Action: "updatePostHoldIRQuality",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      WCRguidId: WCRGUIDID,
      Speed: speed,
      Cable: cable,
      Face: face,
      ONT: ont,
      Wifi: wifissid,
      SelfCare: scp,
      AntiVirus: virus,
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    if (result && result.Response && result.Response.Status !== "Failure") {
    } else {
      const errorMessage = result && result.Response && result.Response.Message;
      //   toast.warning(`${errorMessage}`, {
      //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
      // });
    }
  };
  const handleOnHoldSaveChange = async () => {
    const apiUrl = "process.env.REACT_APP_API_URL";
    const requestData = {
      Action: "holdOrderInstallation",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      HoldCategory: holdCategory,
      HoldReason: "",
      OrderID: "",
      Status: "",
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    if (result && result.Response && result.Response.Status !== "Failure") {
    } else {
      const errorMessage = result && result.Response && result.Response.Message;
      //   toast.warning(`${errorMessage}`, {
      //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
      // });
    }
  };
  const navigateToDetails = (dataArray) => {
    navigate("/editItemConsumption", { state: { data: dataArray } });
  };
  const navigateToEditEquip = (dataArray) => {
    navigate("/editEquipmentConsumption", { state: { data: dataArray } });
  };

  const navigateToEditService = (dataArray) => {
    navigate("/editServiceConsumptios", { state: { data: dataArray } });
  };

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectProvisoning}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">WCR</span>
        </div>
      </div>
      {/* ************Header end************ */}

      <div className="container-fluid irwcr-container text-center">
        <span className="wcr-status">
          WCR Status :{" "}
          {getWcrInfo[0] ? getWcrInfo[0].WCR.WCRConsumptionStatus : ""}
        </span>

        <hr />
      </div>

      <div className="container-fluid">
        {/* **************Contact Information toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Customer Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* **************Contact Information toggle******************* */}

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2 m-1">
              <p className="wcr-customer-detail">
                Customer business segment :{" "}
                {getWcrInfo[0] ? getWcrInfo[0].WCR.BusinessSegment : ""}
              </p>
              <p className="wcr-customer-detail">
                POD : {getWcrInfo[0] ? getWcrInfo[0].WCR.Pod : ""}
              </p>
              <p className="wcr-customer-detail">
                Product : {getWcrInfo[0] ? getWcrInfo[0].WCR.Product : ""}
              </p>
              <p className="wcr-customer-detail">
                Reduncancy required :{" "}
                {getWcrInfo[0] ? getWcrInfo[0].WCR.Redundacy : ""}
              </p>
              <p className="wcr-customer-detail">
                Rack required : {getWcrInfo[0] ? getWcrInfo[0].WCR.Rack : ""}
              </p>
              <p className="wcr-customer-detail">
                Technical contact person Name :{" "}
                {getWcrInfo[0] ? getWcrInfo[0].WCR.TechContactName : ""}
              </p>
              <p className="wcr-customer-detail">
                Technical contact person Number :{" "}
                {getWcrInfo[0] ? getWcrInfo[0].WCR.Techcontactnumber : ""}
              </p>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form2")}
        >
          <span className="toggle-text">Item Consumption Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form2" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form2"
          >
            <div className="col text-center ">
              <button
                type="submit"
                className="btn text-light mt-2 mb-3 w-75 add-item-btn mx-auto"
                onClick={redirectToAddItem}
              >
                ADD ITEM CONSUMPTION
              </button>
            </div>
            {/**********Installation Address form******** */}
            <form className="Installation-form">
              {getWcrInfo.map((wcr, index) => (
                <div className="form-floating" key={index}>
                  {wcr.itemConsumtionList.map((item, itemIndex) => (
                    <div className="col" key={itemIndex}>
                      <div className="card mb-3">
                        <div className="m-3 card-data">
                          <div>
                            <p className="wcr-card-text">Item : {item.Item}</p>
                            <p className="wcr-card-text">
                              SubItem : {item.SubItem}{" "}
                            </p>
                            <p className="wcr-card-text">
                              ItemType : {item.ItemType}{" "}
                            </p>
                            <p className="wcr-card-text">
                              ItemCode : {item.ItemCode}{" "}
                            </p>
                            <p className="wcr-card-text">
                              Serial Num : {item.SerialNumber}{" "}
                            </p>
                            <p className="wcr-card-text">
                              Quantity : {item.Quantity}
                            </p>
                            {/* <p className="wcr-card-text">Segment : </p>
                          <p className="wcr-card-text" style={{lineHeight:"18px"}}>Address : </p> */}

                            <div className="row">
                              <div className=" col-6 text-center ">
                                <button
                                  type="submit"
                                  className="btn text-light edit-wcr-btn edit-btn rounded-pill"
                                  onClick={() => navigateToDetails(item)}
                                >
                                  EDIT
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  type="submit"
                                  className="btn text-light bg-dark delete-btn rounded-pill"
                                  onClick={() => handleDeleteItem(item.ItemID)}
                                >
                                  DELETE
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form3")}
        >
          <span className="toggle-text">Equipment Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {activeForm === "form3" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            <div className="col text-center ">
              <button
                type="submit"
                className="btn text-light mt-2 mb-3 w-75 add-item-btn mx-auto"
                onClick={redirectToAddEqup}
              >
                ADD EQUIPMENT
              </button>
            </div>
            {/**********Installation Address form******** */}
            <form className="Installation-form">
              {getWcrInfo.map((wcr, index) => (
                <div className="form-floating" key={index}>
                  {wcr.EquipmentDetailsList.map((item, itemIndex) => (
                    <div className="col" key={itemIndex}>
                      <div className="card mb-3">
                        <div className="m-3 card-data">
                          <div>
                            <p className="wcr-card-text">Item : {item.Item}</p>
                            <p className="wcr-card-text">
                              SubItem : {item.SubItem}{" "}
                            </p>
                            <p className="wcr-card-text">
                              ItemType : {item.ItemType}{" "}
                            </p>
                            <p className="wcr-card-text">
                              ItemCode : {item.ItemCode}{" "}
                            </p>
                            <p className="wcr-card-text">
                              Serial No.:/Lot no. : {item.SerialNumber}{" "}
                            </p>
                            <p className="wcr-card-text">
                              Quantity : {item.Quantity}
                            </p>
                            {/* <p className="wcr-card-text">Segment : </p>
                          <p className="wcr-card-text" style={{lineHeight:"18px"}}>Address : </p> */}

                            <div className="row">
                              <div className=" col-6 text-center">
                                <button
                                  type="submit"
                                  className="btn text-light edit-wcr-btn edit-btn  rounded-pill"
                                  onClick={() => navigateToEditEquip(item)}
                                >
                                  EDIT
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  type="submit"
                                  className="btn text-light bg-dark delete-btn rounded-pill"
                                  onClick={() => handleDeleteItem(item.ItemID)}
                                >
                                  DELETE
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Customer Network</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form4" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="wifiSsid"
                  name="wifiSsid"
                  value={userWcrData.wifiSsid}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  WI-FI SSID
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="RxPower"
                  name="RxPower"
                  //   value={getWcrInfo[0] ? getWcrInfo[0].CusotmerNetwork.RxPower : ""}
                  value={userWcrData.RxPower}
                  onChange={handleChange}
                  disabled
                  style={{backgroundColor:"transparent"}}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Rx Power
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="TxPower"
                  name="TxPower"
                  // maxLength="10"
                        pattern="[0-9]{10}"
                  //   value={getWcrInfo[0] ? getWcrInfo[0].CusotmerNetwork.TxPower : ""}
                  value={userWcrData.TxPower}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      isDigit ||
                      allowedKeys.includes(e.key)
                      // && (getquantity.length < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Tx Power
                </label>
              </div>

              {/* <div className="input-box form-floating">
                
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="reduncancyRequired"
                  name="reduncancyRequired"
                  value={
                    getWcrInfo[0] ? getWcrInfo[0].CusotmerNetwork.SpeedWifi : ""
                  }
                  //   onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Speed Wi-Fi
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="rackRequired"
                  name="rackRequired"
                  value={
                    getWcrInfo[0] ? getWcrInfo[0].CusotmerNetwork.SpeedLan : ""
                  }
                  //   onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Speed- LAN
                </label>
              </div> */}
              <div>
                {/* Speed Wi-Fi Input */}
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputSpeedWF"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleSpeedWFFileChange}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder="Type Speed Wi-Fi or Click Camera Icon"
                    className="form-control input-text form-control-sm mt-1"
                    id="speedWifi"
                    name="speedWifi"
                    value={wifiSpeed || fileNameSpeedWF}
                    style={{ background: "transparent" }}
                    onChange={handleWifiSpeedChange}
                  />
                  <i
                    className="fa-solid fa-camera fa-camera-icon"
                    onClick={() =>
                      openCameraCN("cameraFileInputSpeedWF", "speedWifi")
                    }
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  ></i>
                  <label
                    htmlFor="speedWifi"
                    className="mt-2"
                    style={{ top: "-20%" }}
                  >
                    Speed Wi-Fi
                  </label>
                </div>

                {/* Speed LAN Input */}
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputSpeedLAN"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleSpeedLANFileChange}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder="Type Speed LAN or Click Camera Icon"
                    className="form-control input-text form-control-sm mt-1"
                    id="speedLan"
                    name="speedLan"
                    value={lanSpeed || fileNameSpeedLAN}
                    style={{ background: "transparent" }}
                    onChange={handleLanSpeedChange}
                  />
                  <i
                    className="fa-solid fa-camera fa-camera-icon"
                    onClick={() =>
                      openCameraCN("cameraFileInputSpeedLAN", "speedLan")
                    }
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  ></i>
                  <label
                    htmlFor="speedLan"
                    className="mt-2"
                    style={{ top: "-20%" }}
                  >
                    Speed LAN
                  </label>
                </div>
              </div>

              <div className=" text-center mt-5 mb-5">
                <button
                  type="button"
                  className="btn text-light ir-btn mx-auto rounded-pill"
                  onClick={handleSaveCustomerNetwork}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form5")}
        >
          <span className="toggle-text">Installation Parameters</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {activeForm === "form5" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form5"
          >
            <form className="contact-form p-2">
              <div className="">
                <label className="select-search-label mt-1">
                  Speed test results shown to Customer
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={speedTest}
                  isSearchable={false}
                  onChange={handleSelectSpeedTest}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>
              <div className="">
                <label className="select-search-label mt-1">
                  Cable_crimped to the wall properly
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={cableCrimp}
                  isSearchable={false}
                  onChange={handleSelectCableCrimp}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>
              <div className="">
                <label className="select-search-label mt-1">
                  Face plate mount to the wall properly
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={facePlate}
                  isSearchable={false}
                  onChange={handleSelectFacePlate}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  ONT login details shared with Customer
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={ontLogin}
                  isSearchable={false}
                  onChange={handleSelectOntLogin}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Wi-Fi SSID and Password Changed info
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={wifiSsid}
                  isSearchable={false}
                  onChange={handleSelectWifiSsid}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Education customer Regarding SelfCare Portal
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={selectScp}
                  isSearchable={false}
                  onChange={handleSelectScp}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">Antivirus</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select Type"
                  styles={style}
                  value={selectAntiVirus}
                  isSearchable={false}
                  onChange={handleSelecAntiVirus}
                  options={optionSpeedTest.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>
              <div className=" text-center mt-5 mb-5">
                <button
                  type="button"
                  className="btn text-light ir-btn mx-auto rounded-pill"
                  onClick={handleSaveInstallation}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}
        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form6")}
        >
          <span className="toggle-text">Engineer Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form6" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form6"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="businessSegment"
                  name="businessSegment"
                  value={
                    getWcrInfo[0] ? getWcrInfo[0].EngineerDetails.EngName : ""
                  }
                  //   onChange="{handleChange}"
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Engineer Name
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="installationCode"
                  name="installationCode"
                  maxLength="6"
                        pattern="[0-9]{10}"
                  value={userWcrData.installationCode}

                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userWcrData.installationCode.length < 6 || e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Installation Code
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="Product"
                  name="Product"
                  value={engCreatedOn}
                  onChange={handleCreatedOn}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Created On
                </label>
              </div>
              <div className=" text-center mt-5 mb-5">
                <button
                  type="button"
                  className="btn text-light ir-btn mx-auto rounded-pill"
                  onClick=""
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form7")}
        >
          <span className="toggle-text">Service Consumption</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form7" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form7"
          >
            <div className="col text-center ">
              <button
                type="submit"
                className="btn text-light mt-2 mb-3 w-75 add-item-btn mx-auto"
                onClick={redirectServiceConsumpton}
              >
                ADD SERVICE
              </button>
            </div>
            {/**********Installation Address form******** */}
            <form className="Installation-form">
              {getWcrInfo.map((wcr, index) => (
                <div className="form-floating" key={index}>
                  {wcr.serviceConsumtionList.map((item, itemIndex) => (
                    <div className="col" key={itemIndex}>
                      <div className="card mb-3">
                        <div className="m-2 card-data">
                          <div>
                            <p className="wcr-card-text">Item : {item.Item}</p>
                            <p className="wcr-card-text">
                              SubItem : {item.SubItem}{" "}
                            </p>
                            <p className="wcr-card-text">
                              ItemType : {item.ItemType}{" "}
                            </p>
                            <p className="wcr-card-text">
                              ItemCode : {item.ItemCode}{" "}
                            </p>

                            <p className="wcr-card-text">
                              Quantity : {item.Quantity}
                            </p>
                            {/* <p className="wcr-card-text">Segment : </p>
                          <p className="wcr-card-text" style={{lineHeight:"18px"}}>Address : </p> */}

                            <div className="row">
                              <div className=" col-6 text-center ">
                                <button
                                  type="submit"
                                  className="btn text-light edit-btn edit-wcr-btn rounded-pill"
                                  onClick={() => navigateToEditService(item)}
                                >
                                  EDIT
                                </button>
                              </div>
                              <div className="col-6 ">
                                <button
                                  type="submit"
                                  className="btn text-light bg-dark delete-btn rounded-pill"
                                  onClick={() => handleDeleteItem(item.ItemID)}
                                >
                                  DELETE
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form8")}
        >
          <span className="toggle-text">On Hold</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {activeForm === "form8" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form8"
          >
            {/**********Installation Address form******** */}
            <form className="Installation-form p-2">
              <div className="">
                <label className="select-search-label mt-1">
                  Hold Category
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Hold Category"
                  styles={style}
                  value={holdCategory}
                  isSearchable={false}
                  onChange={handleSelectHoldCategory}
                  options={holdOpts}
                />
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="businessSegment"
                  name="businessSegment"

                  value={engHoldReason}
                    onChange={handleSelectHoldReason}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Hold Reason
                </label>
              </div>
              <div className=" text-center mt-5 mb-5">
                <button
                  type="button"
                  className="btn text-light ir-btn mx-auto rounded-pill"
                  onClick={handleOnHoldSaveChange}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form9")}
        >
          <span className="toggle-text">Remarks</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form9" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form9"
          >
            {/**********Installation Address form******** */}
            <form className="Installation-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="remark"
                  name="remark"
                  value={userWcrData.remark}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Remarks
                </label>
              </div>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form10")}
        >
          <span className="toggle-text">Misc Work Cost</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form10" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form10"
          >
            {/**********Installation Address form******** */}
            <form className="Installation-form p-2">
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="miscWorkCost"
                  name="miscWorkCost"
                  maxLength="6"
                        pattern="[0-9]{10}"
                  value={userWcrData.miscWorkCost}

                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userWcrData.miscWorkCost.length < 6 || e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Misc Work Cost
                </label>
              </div>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleAttachmentClick("form11")}
        >
          <span className="toggle-text">Attachments</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {attachForm === "form11" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form11"
          >
            {/**********Attachments form******** */}
            <form className="contact-form p-2">
              <div
                className="input-box form-floating"
                style={{ position: "relative" }}
              >
                <input
                  id="cameraFileInput"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  value={fileName}
                  accept="image/*"
                  capture="environment"
                  style={{ background: "transparent" }}
                  onClick={openCamera}
                  readOnly
                />
                <i
                  className="fa-solid fa-camera fa-camera-icon"
                  onClick={openCamera}
                ></i>
                <label htmlFor="floatingInput" className="paperclip mt-2">
                  Capture Image
                </label>
              </div>
              {loaders ? (
                <div className="loader-wrap">
                  <div className="loader text-center">
                    <img src={loader} alt="loading...." />
                  </div>
                </div>
              ) : (
                documentfile &&
                documentfile.map((item, index) => (
                  <div className="row image-contain m-1" key={index}>
                    <div className="col-10 mb-1">
                      <span>{item.Filename}</span>
                    </div>
                    <div className="col-2 mb-1">
                      <span
                        className="icon-wrapper"
                        onClick={() =>
                          handleDownload(item.Filename, item.Attachment)
                        }
                      >
                        <i className="fa-solid fa-arrow-down"></i>
                      </span>
                    </div>
                  </div>
                ))
              )}
            </form>
          </div>
        )}

        <div className=" text-center mt-5 mb-5">
          <button
            type="submit"
            className="btn text-light ir-btn mx-auto rounded-pill"
            onClick=""
          >
            WCR
          </button>
        </div>
      </div>
    </>
  );
};

export default InstallationWCR;
